<template>
    <div>
        <Toast />
        <div class="card">
            <h5>Importación de Archivo de Pagos</h5>        
        </div>        
        <div class="card">
            <Steps :model="items" :readonly="true" />
        </div>

        <router-view v-slot="{Component}" :key="keyUpdate" :formData="condiciones" @prevPage="prevPage($event)" @nextPage="nextPage($event)" @complete="complete">
            <keep-alive>
                <component :is="Component" />
            </keep-alive>
        </router-view>

    </div>
</template>
<script>
import { CURRENT_APP_MODE } from '../../service/constants';

export default {
    data() {
        return {
            appMode: CURRENT_APP_MODE,
            keyUpdate: 0,
            condiciones: {
                id_perfil: '',
                id_moneda: '',
                errores: false,
                archivo: '',
                movs: []
			},                     
            items: [{
                label: 'Selección de Perfil',
                to: '/impcxc',
            },
            {
                label: 'Revisión',
                to: '/impcxcrevision'
            },      
            {
                label: 'Resumen',
                to: '/impcxcresumen'
            }            
            ],
            formObject: {}
        }
    },
    methods: {
        nextPage(event) {
            this.condiciones.id_perfil = event.condiciones.id_perfil;
            this.condiciones.id_moneda = event.condiciones.id_moneda;
            this.condiciones.archivo = event.condiciones.archivo;
            this.condiciones.errores = event.condiciones.errores;
            this.condiciones.movs = event.condiciones.movs;

            let path = this.items[event.pageIndex + 1].to;
            
            if((event.pageIndex == 1) || (event.pageIndex == 2)) { //Si es la pagina de revision se debe actualizar para que se recalcule
                this.keyUpdate++;
            }

            this.$router.push(path);
        },
        prevPage(event) {
            this.$router.push(this.items[event.pageIndex - 1].to);
        },
        complete() {
            this.$toast.add({severity:'success', summary:'Pagos importados y procesados!', detail: ''});
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep(b) {
    display: block;
}

::v-deep(.p-card-body) {
    padding: 2rem;
}
</style>